// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M3 2H21V20H22V22H13V20H14V10H10V20H11V22H2V20H3V2ZM5.00079 20H7.99921L8 10H5L5.00079 20ZM19 10H16V20H19L19 10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-dam-2-filled')
export default class Dam2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dam-2-filled',
    }
  }
}
